import type { IFilterTag } from '../types';
import type { IGroupedFilterConfig } from '../configs';

const getGroupedTags = <TFilters>(configs: IGroupedFilterConfig<TFilters>[], filters: TFilters): IFilterTag[] =>
  configs.flatMap(({ key, countKey, label, removable = true }) => {
    const value = filters[countKey] as string[];
    return value?.length > 0 ? [{ key, label: `${ value.length } ${ label }`, isExclude: false, removable }] : [];
  });

export default getGroupedTags;
